<template>
  <div>
    <a-card style="margin-top:20px;">
      <SearchView
        :initialValues="searchData"
        :fetchSearch="handleSearch"
        formLayout="inline"
        :isExpandShowOrNot="false"
        :renderItem="searchSchema"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <TableView></TableView>
    </a-card>
  </div>
</template>

<script>
import mixin from './mixin'
import { SearchView, TableView } from 'lxfintech-fe'
export default {
  data() {
    //这里存放数据
    return {}
  },
  mixins: [mixin],
  components: { SearchView, TableView },

  //方法集合
  methods: {},
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
